import React, { Component } from "react";
import { Divider, Row, Col, Layout, Card, message } from "antd";
import { Link } from "react-router-dom";
// import logo from "../../img/gamatotologo.png";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import Background1 from "../../img/Backgrounds/Background1.png";
import Background2 from "../../img/Backgrounds/Background2.png";
import Background3 from "../../img/Backgrounds/Background3.png";
import Background4 from "../../img/Backgrounds/Background4.png";
import Background5 from "../../img/Backgrounds/Background5.png";
// import Background6 from "../../img/Backgrounds/Background6.png";
import Background7 from "../../img/Backgrounds/Background7.png";
// import Background8 from "../../img/Backgrounds/Background8.png";
import Background9 from "../../img/Backgrounds/Background9.png";
// import Background10 from "../../img/Backgrounds/Background10.png";
// import Background11 from "../../img/Backgrounds/Background11.png";
import "../../App.css";
import VenatusAd from "../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../utilities/constants";

const { Content } = Layout;
const { Meta } = Card;

const catsdata = [
  {
    title: "Compare Cats",
    link: "/comparecats",
    background: Background1,
    description:
      "Select two cats to start comparing their stats now! Calculate their stats as they level up, or check out how they change in their evolved and true forms →",
  },
  {
    title: "All Cats",
    link: "/allcats",
    background: Background2,
    description:
      "Want to see a full list of all the cats? Or sort them by their strengths, or filter them for certain abilities? This is the perfect tool for you →",
  },
  {
    title: "Best Cats",
    link: "/best-cats-for-attack",
    background: Background3,
    description:
      "Curious to know which are the best cats for damage, health, speed, and range? Check out these rankings today, starting with the best cats for attack! More rankings to come →",
  },
  {
    title: "Tier Lists",
    link: "/ultra-souls-tier-list",
    background: Background4,
    description:
      "Check out the uber and legendary tier lists for each set here, starting with Ultra Souls. More lists to come →",
  },
];

const enemiesdata = [
  {
    title: "Enemies",
    link: "/allenemies",
    background: Background5,
    description:
      "Want to figure out how to defeat your worst enemies, like Teacher Bun Bun? Select the enemy you want to find out more about now →",
  },
];

const stagesdata = [
  {
    title: "By Stage Name",
    link: "/allstages/search-by-stage-name",
    background: Background9,
    description:
      "Need to know more about a stage? Find out what enemies appear in it, what triggers their appearance, and more here →",
  },
  {
    title: "By Stage Enemies",
    link: "/allstages/search-by-stage-enemies",
    background: Background7,
    description:
      "Want to optimise your Monthly Missions? Use this to find out exactly which stages to clear with the least amount of energy and time →",
  },
];

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com:5000/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      viewportHeight: 0,
      selectedStage: [],
    };
  }

  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "My Gamatoto Homepage | Battle Cats Wiki for Cat Stats";
    message.success(
      "Korean version up! Click on the menu bar. 한국어 BCKR 버전 이용 가능! 메뉴 바를 클릭하세요.",
      1
    );
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }
    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  render() {
    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              maxWidth: this.state.viewportWidth - 104,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            MyGamatoto
          </h1>
          <div style={{ paddingTop: "10px" }}></div>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width-max">
            <div>
              <Row style={{ padding: "16px 0 0px 0" }}>
                <h2
                  style={{
                    padding: "8px 0 16px 0",
                    marginBottom: "6px",
                    maxWidth: this.state.viewportWidth - 104,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  All About the Cats
                </h2>
                <Row
                  gutter={[16, 16]}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Col
                    className="homepagecol"
                    xs={10}
                    sm={6}
                    flex="1 0 25%"
                    style={{ flexWrap: "wrap" }}
                  >
                    <Link to={catsdata[0].link}>
                      <Card
                        style={{
                          whiteSpace: "normal",
                          height: "100%",
                          // backgroundColor: "#f9f9f9",
                        }}
                        cover={
                          <img
                            alt={catsdata[0].title}
                            src={catsdata[0].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={catsdata[0].title}
                          description={catsdata[0].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                  <Col
                    className="homepagecol"
                    xs={10}
                    sm={6}
                    flex="1 0 25%"
                    style={{ flexWrap: "wrap" }}
                  >
                    <Link to={catsdata[1].link}>
                      <Card
                        style={{
                          whiteSpace: "normal",
                          height: "100%",
                        }}
                        cover={
                          <img
                            alt={catsdata[1].title}
                            src={catsdata[1].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={catsdata[1].title}
                          description={catsdata[1].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                  <Col className="homepagecol" xs={10} sm={6} flex="1 0 25%">
                    <Link to={catsdata[2].link}>
                      <Card
                        style={{
                          whiteSpace: "normal",
                          height: "100%",
                        }}
                        cover={
                          <img
                            alt={catsdata[2].title}
                            src={catsdata[2].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={catsdata[2].title}
                          description={catsdata[2].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                  <Col className="homepagecol" xs={10} sm={6} flex="1 0 25%">
                    <Link to={catsdata[3].link}>
                      <Card
                        style={{
                          whiteSpace: "normal",
                          height: "100%",
                        }}
                        cover={
                          <img
                            alt={catsdata[3].title}
                            src={catsdata[3].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={catsdata[3].title}
                          description={catsdata[3].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                </Row>
              </Row>
              <Row style={{ padding: "16px 0 0px 0" }}>
                <h2
                  style={{
                    padding: "8px 0 16px 0",
                    marginBottom: "6px",
                    maxWidth: this.state.viewportWidth - 104,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  All About the Enemies
                </h2>
                <Row
                  gutter={[16, 16]}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Col
                    className="homepagecol"
                    xs={10}
                    sm={6}
                    flex="1 0 25%"
                    style={{ flexWrap: "wrap" }}
                  >
                    <Link to={enemiesdata[0].link}>
                      <Card
                        style={{ whiteSpace: "normal", height: "100%" }}
                        cover={
                          <img
                            alt={enemiesdata[0].title}
                            src={enemiesdata[0].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={enemiesdata[0].title}
                          description={enemiesdata[0].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                  <Col
                    className="homepagecol"
                    xs={10}
                    sm={6}
                    flex="1 0 25%"
                    style={{ flexWrap: "wrap" }}
                  ></Col>
                </Row>
              </Row>
              <Row style={{ padding: "16px 0 0px 0" }}>
                <h2
                  style={{
                    padding: "8px 0 16px 0",
                    marginBottom: "6px",
                    maxWidth: this.state.viewportWidth - 104,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  All About the Stages
                </h2>
                <Row
                  gutter={[16, 16]}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Col
                    className="homepagecol"
                    xs={10}
                    sm={6}
                    flex="1 0 25%"
                    style={{ flexWrap: "wrap" }}
                  >
                    <Link to={stagesdata[0].link}>
                      <Card
                        style={{ whiteSpace: "normal", height: "100%" }}
                        cover={
                          <img
                            alt={stagesdata[0].title}
                            src={stagesdata[0].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={stagesdata[0].title}
                          description={stagesdata[0].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                  <Col
                    className="homepagecol"
                    xs={10}
                    sm={6}
                    flex="1 0 25%"
                    style={{ flexWrap: "wrap" }}
                  >
                    <Link to={stagesdata[1].link}>
                      <Card
                        style={{ whiteSpace: "normal", height: "100%" }}
                        cover={
                          <img
                            alt={stagesdata[1].title}
                            src={stagesdata[1].background}
                            style={{ height: "180px" }}
                          />
                        }
                      >
                        <Meta
                          style={{ height: "100%" }}
                          title={stagesdata[1].title}
                          description={stagesdata[1].description}
                        />
                      </Card>
                    </Link>
                  </Col>
                </Row>
              </Row>
            </div>
          </Content>
        </Layout>
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="9632811500"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}

        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <div class="vm-placement" id="vm-av" data-format="isvideo"></div> */}
      </div>
    );
  }
}

export default Homepage;

Homepage.propTypes = {
  applyViewportChange: PropTypes.number,
};

Homepage.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/Homepage.js